import React, {memo, useCallback} from "react";
import PhoneInput from "react-phone-input-2";
import {useTranslation} from "react-i18next";
import {removeAccents} from "../../general/helper";

const Phone = memo(({error, phone, setPhone: setPhoneProp, geoInfo, sendCodeHandler}) => {
	const {t} = useTranslation();
	
	const setPhone = useCallback((value, countryData) => {
		let formattedPhone = value;
		// Check if the phone number includes the country code
		if (value && countryData && value.startsWith(countryData.dialCode) === false) {
			// Prepend the country code if it's missing
			formattedPhone = `${countryData.dialCode}${value}`;
		}
		setPhoneProp(formattedPhone);
	}, [setPhoneProp]);
	
	return (
		<div className="w-full">
			<div className="my-text px-1">
				<h1 className="text-sd text-charcoal mt-2 mb-2">
					{t("enterMobileNumber")}
				</h1>
				<p className="text-sm mt-2 mb-4">{t("willSendYouCode")}</p>
			</div>
			<div
				onClick={(e) => e.preventDefault()}
				className="w-full max-w-full px-1"
			>
				<PhoneInput
					containerClass="w-full"
					inputClass="w-full"
					value={phone}
					onChange={setPhone}
					inputProps={{
						name: "phone",
						required: true,
						autoFocus: true,
					}}
					specialLabel={false}
					country={
						geoInfo?.country_code ? geoInfo.country_code.toLowerCase() : "gr"
					}
					jumpCursorToEnd={false}
				/>
				{error && (
					<p className="text-center my-text text-sm text-red-500">
						{t("invalidMobile")}
					</p>
				)}
					<button
						type="button"
						onClick={() => sendCodeHandler(phone)}
						className="border-2 border-black border-solid px-4 py-3 font-semibold text-base w-full mt-4"
					>
						{`${removeAccents(t("sendCode"))}`}
					</button>
			</div>
		</div>
	);
});

export default Phone;
